<template>
    <div class="lead-time-container">
        <template v-for="(c, index) in validator.leadTimes.$each.$iter">
            <div :key="`lead-time-wrapper-${index}`" class="lead-time-item">
                <TimeSpanInput
                    :value="c.$model"
                    :show-hours="false"
                    :show-minutes="false"
                    :show-seconds="false"
                    @changed="handleTimeDelayChanged(index, $event)"
                    :validator="c"
                />
                <md-button
                    title="Remove value"
                    class="md-danger md-just-icon md-round remove-button"
                    @click.prevent="removeValue(index)"
                >
                    <md-icon>close</md-icon>
                </md-button>
            </div>
        </template>

        <div v-if="values.length < maxItems" class="condition-button-wrapper">
            <md-button @click.prevent="addValue">Add value</md-button>
        </div>
    </div>
</template>

<script>
import TimeSpanInput from '@/components/TimeSpanInput';

export default {
    name: 'TimingLeadTime',
    props: {
        values: {
            type: Array,
            default: () => []
        },
        maxItems: {
            type: Number,
            default: () => 3
        },
        validator: { type: Object, required: true }
    },
    components: { TimeSpanInput },
    methods: {
        handleTimeDelayChanged(index, newValue) {
            // console.log('Time delay changed index:', index);
            // console.log('Time delay changed newValue:', newValue);
            const updatedValues = [...this.values];
            updatedValues[index] = newValue.formatted;
            this.$emit('changed', updatedValues);
        },
        removeValue(index) {
            const updatedValues = [...this.values];
            updatedValues.splice(index, 1);
            this.$emit('changed', updatedValues);
        },
        addValue() {
            const updatedValues = [...this.values, '1.00:00:00'];
            this.$emit('changed', updatedValues);
        }
    }
};
</script>

<style scoped>
.lead-time-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    margin-bottom: 20px;
}
.lead-time-item {
    display: flex;
    align-items: center; /* vertically center items */
    gap: 8px; /* space between input and button */
}
.md-button.remove-button {
    min-width: 24px;
    width: 24px;
    height: 24px;
    font-size: 12px;

    .md-icon.md-icon-font.md-theme-default {
        color: red !important;
    }
}
</style>
